import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { HistoryServiceModel } from './history-service.model';

export class HistoryServiceAckResponse extends GlobalResponseObject{
    data?: HistoryServiceModel[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: HistoryServiceModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 